<template>
  <v-icon v-if="isOverdue" small>mdi-alert</v-icon>
  <span v-else class="grey--text">—</span>
</template>

<script>
export default {
  props: { item: { type: Object, required: true } },
  computed: {
    isOverdue() {
      return !!(this.item?.__isOverdue ?? this.item?.overdue);
    },
  },
};
</script>
